// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* v13 sensor list. The reset action is the primary control; each sensor group is
 * a kt-section card holding a "select all" top-link plus one action row per
 * sensor. */

/* The SSN group's "select all" top-link is intentionally hidden — the group is
 * too large to select at once. The bottom-icon callback only clears the inline
 * display, which reverts to this rule, so it stays hidden. */
#list-of-sensors .sensor-group-section[data-sensor-group="ssn"] .sensor-top-link {
  display: none;
}

/* Category divider separating surveillance sensors from TT&C tracking
 * networks. */
#list-of-sensors .sensor-category-label {
  margin: 14px 6px 6px;
  font-size: 0.72em;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--color-dark-text-muted);
}

#list-of-sensors .sensor-category-label:first-child {
  margin-top: 4px;
}

/* Group header row: title on the left, a compact marker toggle pinned right. The
 * toggle draws/removes the group's 100 km sensor-location marker lines. */
#sensor-list-content .sensor-group-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

#sensor-list-content .sensor-group-header-text {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Marker toggle. Following the app status palette it reads red when off (markers
 * available) and green when enabled. */
#sensor-list-content .sensor-mark-toggle {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: var(--colorCritical, rgb(255, 42, 4));
  cursor: pointer;
  opacity: 0.85;
  transition: color 0.15s ease, background-color 0.15s ease, opacity 0.15s ease;
}

#sensor-list-content .sensor-mark-toggle:hover {
  opacity: 1;
  background: var(--color-dark-border);
}

#sensor-list-content .sensor-mark-toggle.is-marked {
  color: var(--colorNormal, rgb(0, 226, 0));
  opacity: 1;
}

#sensor-list-content .sensor-mark-toggle .material-icons {
  font-size: 16px;
  line-height: 1;
}

/* Sensor row label: name grows to fill the row, the muted system tag sits beside
 * it, and the operator chip rides next to the chevron. */
#sensor-list-content .kt-action-label {
  display: flex;
  align-items: baseline;
  gap: 8px;
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
}

#sensor-list-content .sensor-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

#sensor-list-content .sensor-system {
  flex-shrink: 0;
  font-size: 0.8em;
  color: var(--color-dark-text-muted);
}

/* Operator / affiliation chip riding next to the chevron. */
#sensor-list-content .sensor-badge {
  flex-shrink: 0;
  margin-left: 8px;
  background: var(--color-dark-background);
  border: 1px solid var(--color-dark-border);
  border-radius: 10px;
  padding: 1px 7px;
  font-size: 0.72em;
  letter-spacing: 0.04em;
  color: var(--color-dark-text-accent);
  text-align: center;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/plugins/sensor-list/sensor-list.css"],"names":[],"mappings":"AAAA;;YAEY;;AAEZ;;6DAE6D;AAC7D;EACE,aAAa;AACf;;AAEA;cACc;AACd;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,eAAe;AACjB;;AAEA;0EAC0E;AAC1E;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;uCACuC;AACvC;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,4CAA4C;EAC5C,eAAe;EACf,aAAa;EACb,6EAA6E;AAC/E;;AAEA;EACE,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,yCAAyC;EACzC,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;yDACyD;AACzD;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA,4DAA4D;AAC5D;EACE,cAAc;EACd,gBAAgB;EAChB,wCAAwC;EACxC,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,oCAAoC;EACpC,kBAAkB;EAClB,mBAAmB;AACrB","sourcesContent":["/* v13 sensor list. The reset action is the primary control; each sensor group is\n * a kt-section card holding a \"select all\" top-link plus one action row per\n * sensor. */\n\n/* The SSN group's \"select all\" top-link is intentionally hidden — the group is\n * too large to select at once. The bottom-icon callback only clears the inline\n * display, which reverts to this rule, so it stays hidden. */\n#list-of-sensors .sensor-group-section[data-sensor-group=\"ssn\"] .sensor-top-link {\n  display: none;\n}\n\n/* Category divider separating surveillance sensors from TT&C tracking\n * networks. */\n#list-of-sensors .sensor-category-label {\n  margin: 14px 6px 6px;\n  font-size: 0.72em;\n  font-weight: 600;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--color-dark-text-muted);\n}\n\n#list-of-sensors .sensor-category-label:first-child {\n  margin-top: 4px;\n}\n\n/* Group header row: title on the left, a compact marker toggle pinned right. The\n * toggle draws/removes the group's 100 km sensor-location marker lines. */\n#sensor-list-content .sensor-group-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n#sensor-list-content .sensor-group-header-text {\n  flex: 1 1 auto;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Marker toggle. Following the app status palette it reads red when off (markers\n * available) and green when enabled. */\n#sensor-list-content .sensor-mark-toggle {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  border: none;\n  border-radius: 50%;\n  background: transparent;\n  color: var(--colorCritical, rgb(255, 42, 4));\n  cursor: pointer;\n  opacity: 0.85;\n  transition: color 0.15s ease, background-color 0.15s ease, opacity 0.15s ease;\n}\n\n#sensor-list-content .sensor-mark-toggle:hover {\n  opacity: 1;\n  background: var(--color-dark-border);\n}\n\n#sensor-list-content .sensor-mark-toggle.is-marked {\n  color: var(--colorNormal, rgb(0, 226, 0));\n  opacity: 1;\n}\n\n#sensor-list-content .sensor-mark-toggle .material-icons {\n  font-size: 16px;\n  line-height: 1;\n}\n\n/* Sensor row label: name grows to fill the row, the muted system tag sits beside\n * it, and the operator chip rides next to the chevron. */\n#sensor-list-content .kt-action-label {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  flex: 1 1 auto;\n  min-width: 0;\n  overflow: hidden;\n}\n\n#sensor-list-content .sensor-name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n#sensor-list-content .sensor-system {\n  flex-shrink: 0;\n  font-size: 0.8em;\n  color: var(--color-dark-text-muted);\n}\n\n/* Operator / affiliation chip riding next to the chevron. */\n#sensor-list-content .sensor-badge {\n  flex-shrink: 0;\n  margin-left: 8px;\n  background: var(--color-dark-background);\n  border: 1px solid var(--color-dark-border);\n  border-radius: 10px;\n  padding: 1px 7px;\n  font-size: 0.72em;\n  letter-spacing: 0.04em;\n  color: var(--color-dark-text-accent);\n  text-align: center;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
